import { render, staticRenderFns } from "./CustomInputTextForm.vue?vue&type=template&id=1336d039&scoped=true&"
import script from "./CustomInputTextForm.vue?vue&type=script&lang=js&"
export * from "./CustomInputTextForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputTextForm.vue?vue&type=style&index=0&id=1336d039&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1336d039",
  null
  
)

export default component.exports